import React, { MouseEventHandler } from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import ImageLogoComponent from "../../../../components/Image/ImageLogoComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";

import LocationRedIcon from "../../../../assets/icons/location_red.png";
import ButtonComponent from "../../../../components/Button/ButtonComponent";

interface HeaderProps {
    imageLogo?: string;
    nomeEmpresa: string;
    descricao: string;
    cidade: string;
    uf: string;
    aberto: boolean;
    horarioFechamento: string;
    onClickMaisInfo: MouseEventHandler<HTMLButtonElement>;
}

const HeaderComponent = (props: HeaderProps) => {
    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: "center",
            mt: -6
        }}
    >
        <ImageLogoComponent
            sx={{
                width: 80,
                height: 80,
                margin: "auto",
                bgcolor: "red"
            }}
            src={props.imageLogo}
            alt="logo_cardapio"
        />

        <TypographyComponent
            variant="h5" fontWeight="bold" mt={1}
            sx={{
                fontFamily: '"Font 2", "Roboto", "Arial", sans-serif',
                fontWeight: 700,
                fontSize: '1.875rem', // 30px convertido para rem (30/16)
                lineHeight: 1.2,      // 36px / 30px
                letterSpacing: 0,
                textAlign: 'center',
                textTransform: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {props.nomeEmpresa}
        </TypographyComponent>

        <TypographyComponent
            variant="body2" color="text.secondary"
            sx={{
                fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                fontSize: '0.875rem',  // 14px / 16px
                lineHeight: 1.428,     // 20px / 14px
                letterSpacing: '0em',
                textAlign: 'center',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {props.descricao}
        </TypographyComponent>

        <BoxComponent
            component="article"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem',
                padding: '1rem'
            }}
        >
            <ImageLogoComponent
                sx={{
                    width: 18,
                    height: 18
                }}
                src={LocationRedIcon}
                alt="location_icon"
            />
            <TypographyComponent
                variant="body2"
                color="text.secondary"
                sx={{
                    fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                    fontWeight: 400,
                    fontSize: '0.875rem',  // 14px / 16px (padrão de navegadores)
                    lineHeight: 1.42857,   // 20px / 14px
                    letterSpacing: '0em',
                    display: 'inline-flex',
                    alignItems: 'center'
                }}
            >
                {props.cidade} - {props.uf}
            </TypographyComponent>

            <TypographyComponent
                variant="body2"
                //color="text.secondary"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 8,
                    height: 20,
                    lineHeight: 1,
                    p: 0,
                    m: 0,
                    color: "#D1D5DC"
                }}
            >
                •
            </TypographyComponent>

            <ButtonComponent
                id="mais_info"
                variant="outlined"
                onClick={props.onClickMaisInfo}
                sx={{
                    fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                    fontWeight: 600,        // Semi Bold
                    fontSize: '0.875rem',  // 14px / 16px
                    lineHeight: 1.428,     // 20px / 14px
                    letterSpacing: '0em',
                    color: '#E7000B',
                    display: 'inline-flex',
                    alignItems: 'center',
                    borderColor: "transparent"
                }}
            >
                Mais informações
            </ButtonComponent>
        </BoxComponent>

        <TypographyComponent
            variant="body2"
            mt={1}
            fontWeight="bold"
            sx={{
                height: 36,
                fontFamily: '"Font 1", "Roboto", "Arial", sans-serif',
                fontWeight: 700,
                fontSize: '1rem',
                lineHeight: 1.555,     // 28px / 18px
                letterSpacing: 0,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: props.aberto ? "#009689" : "#E7000B"
            }}
        >
            {props.aberto && `Aberto até às ${props.horarioFechamento}`}
            {!props.aberto && `Fechado`}
        </TypographyComponent>
    </ContainerComponent>
}

export default HeaderComponent;